document.addEventListener("DOMContentLoaded", function () {
    // Seleziona tutti i form nella pagina
    document.querySelectorAll("form").forEach(function (form) {
        form.addEventListener("submit", function (event) {
            event.preventDefault(); // Evita il refresh della pagina

            let formData = new FormData(form);
            let resultDiv = form.querySelector(".form-results");

            resultDiv.classList.remove("success");
            resultDiv.classList.remove("error");
            resultDiv.textContent = "";

            fetch(form.action, {
                method: "POST",
                body: formData
            })
                .then(response => response.json())
                .then(data => {

                    if (data.status === "success") {

                        resultDiv.classList.remove("d-none");
                        resultDiv.classList.add("success");
                        resultDiv.textContent = data.message;

                    } else {

                        resultDiv.classList.remove("d-none");
                        resultDiv.classList.add("error");
                        resultDiv.textContent = data.message;

                    }
                })
                .catch(error => {
                    console.error("Errore:", error);
                });
        });
    });
});
